var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "leaves_top" }),
      _vm._v(" "),
      _c("HeaderMenu_Site"),
      _vm._v(" "),
      _c("LateralMenu_Site"),
      _vm._v(" "),
      _c("div", { staticClass: "page-content", attrs: { id: "contact" } }, [
        _c("div", { staticClass: "logo" }),
        _vm._v(" "),
        _c("div", { staticClass: "habillage-header" }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "content", attrs: { id: "form" } }, [
          _c("div", { staticClass: "column left" }, [
            _c("div", [
              _c("span", [_vm._v("Votre message")]),
              _vm._v(" "),
              _c("div", [
                _c("span", [_vm._v("Type de contact *")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form_contactType,
                        expression: "form_contactType",
                      },
                    ],
                    attrs: {
                      id: "field_contactType",
                      name: "field_contactType",
                    },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.form_contactType = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "Entreprise" } }, [
                      _vm._v("Entreprise"),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "Particulier" } }, [
                      _vm._v("Particulier"),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "Collectivité" } }, [
                      _vm._v("Collectivité"),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "Presse" } }, [
                      _vm._v("Presse"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "multiple" }, [
                _c("div", [
                  _c("span", [_vm._v("Email *")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form_email,
                        expression: "form_email",
                      },
                    ],
                    attrs: {
                      type: "text",
                      id: "field_email",
                      name: "field_email",
                    },
                    domProps: { value: _vm.form_email },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.form_email = $event.target.value
                      },
                    },
                  }),
                ]),
                _c("div", [
                  _c("span", [_vm._v("Société (facultatif)")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form_company,
                        expression: "form_company",
                      },
                    ],
                    attrs: {
                      type: "text",
                      id: "field_company",
                      name: "field_company",
                    },
                    domProps: { value: _vm.form_company },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.form_company = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "multiple" }, [
                _c("div", [
                  _c("span", [_vm._v("Nom et prénom *")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form_fullName,
                        expression: "form_fullName",
                      },
                    ],
                    attrs: {
                      type: "text",
                      id: "field_fullName",
                      name: "field_fullName",
                    },
                    domProps: { value: _vm.form_fullName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.form_fullName = $event.target.value
                      },
                    },
                  }),
                ]),
                _c("div", [
                  _c("span", [_vm._v("Téléphone *")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form_phoneNumber,
                        expression: "form_phoneNumber",
                      },
                    ],
                    attrs: {
                      type: "text",
                      id: "field_phoneNumber",
                      name: "field_phoneNumber",
                    },
                    domProps: { value: _vm.form_phoneNumber },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.form_phoneNumber = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", [_vm._v("Votre message *")]),
                _vm._v(" "),
                _c(
                  "textarea",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form_message,
                        expression: "form_message",
                      },
                    ],
                    attrs: { id: "field_message", name: "field_message" },
                    domProps: { value: _vm.form_message },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.form_message = $event.target.value
                      },
                    },
                  },
                  [_vm._v("Un beau message")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "button-container" }, [
                !_vm.isLoading
                  ? _c(
                      "button",
                      {
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.button_sendEmail_onClick },
                      },
                      [_vm._v("Envoyer")]
                    )
                  : _vm._e(),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm._m(1),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content", attrs: { id: "faq" } }, [
          _c("div", { staticClass: "column left" }, [
            _c("ul", [
              _c(
                "li",
                {
                  class: { active: _vm.currentIndex == 1 },
                  on: {
                    click: function ($event) {
                      return _vm.update_faq_block(1)
                    },
                  },
                },
                [_vm._v("Combien de personnes ?")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: { active: _vm.currentIndex == 2 },
                  on: {
                    click: function ($event) {
                      return _vm.update_faq_block(2)
                    },
                  },
                },
                [_vm._v("Désistement / ajout d'une personne")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: { active: _vm.currentIndex == 3 },
                  on: {
                    click: function ($event) {
                      return _vm.update_faq_block(3)
                    },
                  },
                },
                [_vm._v("Utilisation des bons cadeau")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: { active: _vm.currentIndex == 4 },
                  on: {
                    click: function ($event) {
                      return _vm.update_faq_block(4)
                    },
                  },
                },
                [_vm._v("Âge des participants")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: { active: _vm.currentIndex == 5 },
                  on: {
                    click: function ($event) {
                      return _vm.update_faq_block(5)
                    },
                  },
                },
                [_vm._v("Accès P.M.R.")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: { active: _vm.currentIndex == 6 },
                  on: {
                    click: function ($event) {
                      return _vm.update_faq_block(6)
                    },
                  },
                },
                [_vm._v("Durée du jeu / temps de présence")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: { active: _vm.currentIndex == 7 },
                  on: {
                    click: function ($event) {
                      return _vm.update_faq_block(7)
                    },
                  },
                },
                [_vm._v("Offres groupes / entreprises")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: { active: _vm.currentIndex == 8 },
                  on: {
                    click: function ($event) {
                      return _vm.update_faq_block(8)
                    },
                  },
                },
                [_vm._v("Anniversaires, EVC, personnalisation")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: { active: _vm.currentIndex == 9 },
                  on: {
                    click: function ($event) {
                      return _vm.update_faq_block(9)
                    },
                  },
                },
                [_vm._v("Comment réserver ?")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column right" }, [
            _c("div", [
              _vm.currentIndex == 0
                ? _c("div", [
                    _c("span", [_vm._v("Questions fréquentes")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "italic" }, [
                      _vm._v("Choisissez votre question dans la liste"),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(" ")]),
                    _vm._v(" "),
                    _c("p", [_vm._v(" ")]),
                    _vm._v(" "),
                    _vm._m(2),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.currentIndex == 1
                ? _c("div", [
                    _c("span", [_vm._v("Combien de personnes ?")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                                Nos Escape Game sont conçus pour des équipes de 2 à 5 personnes. \n                                Pour des groupes de 6 joueurs, nous pouvons accueillir une personne supplémentaire (23€) \n                                bien que ce ne soit pas idéal pour le déroulement du jeu. \n                                Pour les groupes plus importants, vous devrez réserver plusieurs salles avec un départ simultané.\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(" ")]),
                    _vm._v(" "),
                    _vm._m(3),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.currentIndex == 2
                ? _c("div", [
                    _c("span", [_vm._v("Désistement / ajout d'une personne")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                                Lock Quest® est une activité live, aucun désistement ne sera accepté.\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(" ")]),
                    _vm._v(" "),
                    _vm._m(4),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.currentIndex == 3
                ? _c("div", [
                    _c("span", [_vm._v("Utilisation des bons cadeau")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                                Indiquez simplement le montant de vos bons cadeau dans le formulaire lors de votre inscription. \n                                Ce montant sera automatiquement déduit. \n                                Pensez à apporter votre bon imprimé le jour de votre escape game, ou le montant vous sera réclamé.\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(" ")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                                Attention, si le montant des bons est supérieur à celui de votre réservation, \n                                la différence ne pourra pas vous être remboursée.\n                            "
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.currentIndex == 4
                ? _c("div", [
                    _c("span", [_vm._v("Âge des participants")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                                L’âge minimum conseillé pour participer à nos aventures est d'environ 10 ans.\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(" ")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                                Cet âge minimum est recommandé à cause de la difficulté des énigmes et des défis proposés. \n                                Nos Escape Game ne contiennent pas d’éléments susceptibles de choquer les plus jeunes.\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(" ")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                                Les équipes contenant un ou plusieurs mineurs de moins de 15 ans devront obligatoirement inclure un adulte.\n                            "
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.currentIndex == 5
                ? _c("div", [
                    _c("span", [_vm._v("Accès P.M.R.")]),
                    _vm._v(" "),
                    _vm._m(5),
                    _vm._v(" "),
                    _c("p", [_vm._v(" ")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                                Etant donné l’exiguité des lieux, nous limitons l’accès aux fauteuils roulants à 2 par salle. \n                                Une personne valide doit également être présente dans l’équipe.\n                            "
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.currentIndex == 6
                ? _c("div", [
                    _vm._m(6),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                                Entre votre accueil, les explications, la durée du jeu, le debrief, il faudra prévoir 1h30 sur place.\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(" ")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                                Par exemple, pour une inscription à 18h30, votre aventure se terminera vers 20h.\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(" ")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                                Pour ne pas retarder les autres groupes, nous vous recommandons de vous présenter 10 min avant votre heure d’inscription.\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(" ")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                                Attention, tout retard sera décompté de votre temps de jeu dans la salle !\n                            "
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.currentIndex == 7
                ? _c("div", [_vm._m(7), _vm._v(" "), _vm._m(8)])
                : _vm._e(),
              _vm._v(" "),
              _vm.currentIndex == 8
                ? _c("div", [
                    _c("span", [_vm._v("Anniversaires / EVC")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                                Rendez cet instant unique avec une touche de personnalisation.\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(" ")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                                Fournissez-nous des photos, des informations sur l’événement à fêter, \n                                et nos Game Master se chargeront de concocter quelques surprises personnalisées à votre aventure.\n                            "
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.currentIndex == 9
                ? _c("div", [
                    _c("span", [_vm._v("Comment réserver ?")]),
                    _vm._v(" "),
                    _vm._m(9),
                    _vm._v(" "),
                    _c("p", [_vm._v(" ")]),
                    _vm._v(" "),
                    _vm._m(10),
                    _vm._v(" "),
                    _c("p", [_vm._v(" ")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                                Toutes nos réservations se font en ligne, aucun paiement sur place ne sera accepté.\n                            "
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(11),
      _vm._v(" "),
      _c("Footer", {
        attrs: {
          seo_contentH1:
            "Lock Quest escape game Caen - Nous contacter et foire aux questions",
          seo_contentH2:
            "Une question ? Avez-vous consulté notre FAQ ? Un devis, une facture",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content", attrs: { id: "header" } }, [
      _c("div", [
        _c("div", { staticClass: "bandeau" }, [
          _c("span", [_vm._v("- Nous contacter -")]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "bandeau-wordings" }, [
              _vm._v(
                "\n                            Une question ? Avez-vous consulté notre "
              ),
              _c("a", { attrs: { href: "/contact#faq" } }, [_vm._v("F.A.Q.")]),
              _vm._v(" ?\n                        "),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column right" }, [
      _c("div", [
        _c("span", [_vm._v("Contact")]),
        _vm._v(" "),
        _c("div", [
          _c("span", [_vm._v("07 82 42 47 16")]),
          _vm._v(" "),
          _c("span", [_vm._v("lockquest.escape@gmail.com")]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", { staticClass: "bold" }, [_vm._v("Lock Quest®")]),
          _vm._v(" "),
          _c("span", [_vm._v("6 chemin de Lamballard")]),
          _vm._v(" "),
          _c("span", [_vm._v("14760 Bretteville-sur-Odon")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v(
        "\n                                Vous n'avez pas trouvé votre réponse ?\n                                "
      ),
      _c("br"),
      _vm._v("Contactez-nous "),
      _c("span", { staticClass: "italic" }, [_vm._v("via")]),
      _vm._v(" le formulaire ci-dessus ou\n                                "),
      _c("br"),
      _vm._v("directement au\n                                "),
      _c("br"),
      _vm._v("07 82 42 47 16\n                            "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v("\n                                Nos "),
      _c(
        "a",
        { attrs: { href: "https://www.padquest.fr", target: "_blank" } },
        [_vm._v("jeux de piste en plein air")]
      ),
      _vm._v(
        " sont conçus pour des équipes de 2 à 6 joueurs, \n                                6 équipes peuvent s’affronter simultanément pour un total de 36 participants. \n                                Pour des groupes plus importants, contactez-nous pour nos solutions adaptées.\n                            "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _c("span", { staticClass: "bold" }, [
        _vm._v("Un joueur de dernière minute ?"),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "Il sera bien sûr accepté dans la mesure où votre groupe ne dépasse pas 5 joueurs. \n                                Selon le nombre de personnes final dans votre équipe, le complément de paiement vous sera demandé sur place \n                                "
      ),
      _c("span", { staticClass: "bold" }, [
        _vm._v("par chèque, espèces ou CB"),
      ]),
      _vm._v(".\n                            "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v(
        "\n                                Un escape game nécessitant des déplacements et un travail de fouille, \n                                il est possible que certains passages ne soient pas réalisables par les P.M.R. \n                                Une solution alternative vous sera proposée.\n                                "
      ),
      _c("p", [_vm._v(" ")]),
      _vm._v(
        "\n                                Contactez-nous pour plus de détails au cas par cas.\n                            "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v("Durée du jeu"),
      _c("br"),
      _vm._v("Temps de présence"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v("Offres groupes"),
      _c("br"),
      _vm._v("entreprises"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v("\n                                Consultez notre "),
      _c("a", { attrs: { href: "/entreprises" } }, [_vm._v("page dédiée")]),
      _vm._v(
        " pour découvrir nos offres entreprises.\n                            "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _c("span", { staticClass: "bold" }, [_vm._v("Escape Game")]),
      _vm._v(" "),
      _c("br"),
      _vm._v("Allez sur la "),
      _c("a", { attrs: { href: "/nos-scenarios-escape-caen" } }, [
        _vm._v("page des énigmes"),
      ]),
      _vm._v(
        " puis cliquez sur le bouton “Réserver” de l’Escape Game souhaitée. \n                                Cliquez sur l’horaire et le nombre de personnes souhaité. \n                                Renseignez vos coordonnées dans le formulaire. Procédez au paiement.\n                            "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _c("span", { staticClass: "bold" }, [
        _vm._v("Jeux de piste en plein air"),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v("Les réservations se font en ligne sur le "),
      _c(
        "a",
        { attrs: { href: "https://www.padquest.fr", target: "_blank" } },
        [_vm._v("site dédié")]
      ),
      _vm._v(".\n                            "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { id: "leaves_sides" } }, [
      _c("div", { staticClass: "left" }),
      _vm._v(" "),
      _c("div", { staticClass: "right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }